var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-with-confirm",class:{ 'is-inline': _vm.inline },attrs:{"action":_vm.action,"method":_vm.method},on:{"submit":_vm.onSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }